import {
  EMPTY_FILTERS,
  FilterValues,
  SignalOption,
  Urgency,
  Visibility,
} from 'events/components/FilterGroupingControl/_types';

const URGENCY_TO_BACKEND: Record<Urgency, string> = {
  urgent: 'Emergency',
  needs_attention: 'Needs attention',
  routine: 'Routine',
  informational: 'Informational',
};

const VISIBILITY_TO_BACKEND: Record<Visibility, 'public' | 'private'> = {
  shared: 'public',
  private: 'private',
};

export default function buildEventsListQuery(
  date: string,
  filters: FilterValues = EMPTY_FILTERS
): string {
  const params = new URLSearchParams();
  if (date) params.set('date', date);
  if (filters.urgency)
    params.set('urgency', URGENCY_TO_BACKEND[filters.urgency]);
  if (filters.visibility)
    params.set('visibility', VISIBILITY_TO_BACKEND[filters.visibility]);
  if (filters.department) params.set('department', filters.department);
  if (filters.person) params.set('people', filters.person);
  if (filters.tag) params.set('tags', filters.tag);
  if (filters.source) params.set('source', filters.source);
  if (filters.signal) params.set('signal', filters.signal);
  return params.toString();
}

export function dropUnavailableCameraFilters(
  filters: FilterValues,
  signals: SignalOption[]
): FilterValues {
  if (signals.length === 0) {
    return filters.source || filters.signal
      ? { ...filters, source: null, signal: null }
      : filters;
  }
  const isKnownSignal = signals.some((signal) => signal.id === filters.signal);
  const isPeopleOnly = filters.source === 'user';
  return filters.signal && (!isKnownSignal || isPeopleOnly)
    ? { ...filters, signal: null }
    : filters;
}
